import { combineReducers } from "redux";

import marketplaceReducer from "./marketplace.reducer";

const rootReducer = combineReducers({
  marketplace: marketplaceReducer
});

export default rootReducer;
